export function fetchFeatureFlag(experiments, featureFlagName) {
  const candidateFeature = experiments.find(
    ({ name }) => name === featureFlagName
  );

  // No feature flag found, feature flag is disabled
  if (!candidateFeature) {
    return { enabled: false, properties: {} };
  }

  const properties = candidateFeature.dimensions.reduce(
    (acc, { name, variant }) => {
      acc[name] = variant;
      return acc;
    },
    {}
  );

  return { enabled: true, properties };
}
